import { PolicyDTO } from '@reposit/api-client';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import canopiusLogo from '../../../assets/png/canopius.png';
import falconLogo from '../../../assets/png/falcon.png';
import repositLogo from '../../../assets/png/icon-full-colour.png';
import novusLogo from '../../../assets/png/novus.png';
import IdentifierValue from '../../IdentifierValue';
import { Header5, P2 } from '../../Typography';
import PolicyStatus from '../PolicyStatus';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface PolicyIdProps {
  underwriterId: string;
}

const PolicyIdLabel = styled(Header5)<PolicyIdProps>`
  align-items: center;
  display: flex;
  margin: 0 14px 0 0;
  padding: 0;

  &:before {
    height: 20px;
    width: 20px;
    background-size: 24px;
    ${(props) =>
      props.underwriterId === 'FALCON' &&
      `
      background: transparent url(${falconLogo}) no-repeat center center;
      background-size: 50px;
      height: 50px;
      width: 50px;
      `}
    ${(props) =>
      props.underwriterId === 'CANO' &&
      `
      background: transparent url(${canopiusLogo}) no-repeat center center;
      background-size: 24px;
      `}
    ${(props) =>
      props.underwriterId === 'NOVUS' &&
      `
      background: transparent url(${novusLogo}) no-repeat center center;
      background-size: 18px;
      `}
      ${(props) =>
        props.underwriterId === 'REPOSIT' &&
        `
      background: transparent url(${repositLogo}) no-repeat center center;
      background-size: 24px;
      `}
    content: '';
    display: block;
    margin: -3px 10px 0 0;
  }
`;

const PolicyDatesText = styled(P2)`
  color: ${(props) => props.theme.colors.body2};
  margin-bottom: 0;
`;

interface PolicyHeaderProps {
  policy: PolicyDTO;
}

const PolicyHeader: React.FC<PolicyHeaderProps> = ({ policy: { id, startDate, endDate, status, type } }) => {
  return (
    <Container>
      <PolicyIdLabel underwriterId={type.underwriter.id}>
        <IdentifierValue>{id}</IdentifierValue>
      </PolicyIdLabel>
      <PolicyDatesText>
        {moment(startDate).format('DD/MM/YYYY')} to {moment(endDate).format('DD/MM/YYYY')}
      </PolicyDatesText>
      <PolicyStatus status={status || ''} />
    </Container>
  );
};

export default PolicyHeader;
